export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();
      const apiOrigin = (process.env.REACT_APP_BASE_URL || "https://allezadmin.com")
        .trim()
        .replace(/\/+$/, "");
      if (apiOrigin) {
        config.baseURL = `${apiOrigin}/api/admin/`;
      } else {
        config.baseURL = "/api/admin/";
      }
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.error('API Error:', error);
      
      // Handle different error scenarios
      if (error.response) {
        // Server responded with error status
        const status = error.response.status;
        
        if (status === 401 || status === 403) {
          // Unauthorized or Forbidden - clear auth and redirect to login
          console.log('Authentication failed, redirecting to logout');
          store.dispatch({ type: 'LOGOUT' });
          window.location = "/logout";
          return Promise.reject(error);
        }
        
        if (status >= 500) {
          // Server error - show user-friendly message
          console.error('Server error:', status);
          // Could dispatch a global error action here
        }
      } else if (error.request) {
        // Network error - no response received
        console.error('Network error - no response received:', error.request);
        // Could dispatch a network error action here
      } else {
        // Something else happened
        console.error('Request setup error:', error.message);
      }
      
      return Promise.reject(error);
    }
  );
}
